import React from 'react';
import PropTypes from 'prop-types';
import { useSash } from './hooks/useSash';
import { SaleSash } from './SaleSash';

const ProductTopSash = ({ tags, extraTags, isPDP }) => {
  const { topSash, saleSash } = useSash([...tags, ...extraTags]);

  if (saleSash) {
    return (
      <SaleSash
        text={saleSash.text}
        textColor={saleSash.textColor}
        bgColor={saleSash.bgColor}
        breakWord={saleSash.breakWord}
      />
    );
  }

  if (!topSash || !topSash.label || !isPDP) return null;

  return (
    <div className="sash-base product-text-sash">
      <span className="sash-text">{topSash.label}</span>
    </div>
  );
};

ProductTopSash.propTypes = {
  tags: PropTypes.array.isRequired,
  extraTags: PropTypes.array,
  isPDP: PropTypes.bool
};

ProductTopSash.defaultProps = {
  extraTags: [],
  isPDP: false
};

export { ProductTopSash };
